import Modal from "./modal";

class ModalNonBlocked extends Modal {
  get isBlocked() {
    return false;
  }
}

export default ModalNonBlocked;